module.exports = __webpack_public_path__ + "assets/img/defaultImage.37846a45.jpg";